import * as z from 'zod/mini';
import { LIMITS } from '../../../consts';

export const submissionSchema = z.object({
    unexpected: z.string().check(z.trim(), z.minLength(1), z.maxLength(LIMITS.answer)),
    made: z.string().check(z.trim(), z.minLength(1), z.maxLength(LIMITS.answer)),
    proud: z.string().check(z.trim(), z.minLength(1), z.maxLength(LIMITS.answer)),
    about: z.string().check(z.trim(), z.minLength(1), z.maxLength(LIMITS.answer)),
    name: z.string().check(z.trim(), z.minLength(1), z.maxLength(LIMITS.name)),
    email: z.email(),
    location: z.string().check(z.trim(), z.minLength(1), z.maxLength(LIMITS.location)),
    linkedin: z.union([z.literal(''), z.url()]),
});

export type Submission = z.infer<typeof submissionSchema>;
